var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fancy-table',{attrs:{"layoutArray":_vm.trs},scopedSlots:_vm._u([{key:"item",fn:function({item,index}){return [_c('fancy-table-item',{attrs:{"trItem":item,"index":index}},[_vm._v(" test111 ")])]}}])}),_vm._v(" "+_vm._s(_vm.trs)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }